import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ShiftMstApi } from '../api/shiftmst.api';
import { switchMap, map } from 'rxjs/operators';

import { ShiftMstData, ShiftMst } from '../../../interfaces/masters/shiftmst' ;
@Injectable()
export class ShiftMstService extends ShiftMstData {

    constructor(private api: ShiftMstApi) {
      super();
    }
  
  
    list(url: string): Observable<ShiftMst[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<ShiftMst>{
        return this.api.getById(url);
    }
  
    create(url: string, data:ShiftMst): Observable<ShiftMst[]> {
      debugger;
      return this.api.add(url,data);
    }
  
    update(url: string, data:ShiftMst): Observable<any> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  